import { phoneNumberSanitizationMatcher } from '../../utility/general-utility.js';
import { PhoneNumberValidator } from './phone-number-validator.js';

export class GenericPhoneNumberValidator extends PhoneNumberValidator {
  constructor(
    private minLength: number = 7,
    private maxLength: number = 13,
  ) {
    super();
  }

  validateFormattedNumber(number: string): boolean {
    const sanitizedNumber = number.replace(phoneNumberSanitizationMatcher, '');
    return sanitizedNumber !== null;
  }

  validate(number: string): boolean {
    const sanitizedNumber = this.sanitize(number);

    if(sanitizedNumber === null) {
      return false;
    }

    if(this.minLength !== null && sanitizedNumber.length < this.minLength) {
      return false;
    }

    if(this.maxLength !== null && sanitizedNumber.length > this.maxLength) {
      return false;
    }

    return true;
  }
}
